export default __webpack_public_path__ + "static/media/fleischer.b312f069.jpg";